import React from 'react'

export const Footer = () => {
    return (
        <footer>
            <p>Design & Built by</p>
            <a href="https://imranh.netlify.com" target="_blank">Imran</a>
        </footer>
    )
}
